import type { ReactElement } from 'react';

import {
  compactTextFieldStyles,
  ScaleDropdownSelect,
  ScaleDropdownSelectItem,
  ScaleTextField,
} from '@cloudorder/ui';

import type { TenantMasterOption } from '@/shared/domain/tenancy';

type Props = {
  readonly name: string;
  readonly country: string;
  readonly language: string;
  readonly countries: readonly TenantMasterOption[];
  readonly languages: readonly TenantMasterOption[];
  readonly nameLabel: string;
  readonly nameHelp: string;
  readonly countryLabel: string;
  readonly countryHelp: string;
  readonly languageLabel: string;
  readonly languageHelp: string;
  readonly onNameChange: (value: string) => void;
  readonly onCountryChange: (value: string) => void;
  readonly onLanguageChange: (value: string) => void;
};

function optionLabel(option: TenantMasterOption): string {
  return `${option.name} (${option.code})`;
}

export function TenantDetailsFields({
  name,
  country,
  language,
  countries,
  languages,
  nameLabel,
  nameHelp,
  countryLabel,
  countryHelp,
  languageLabel,
  languageHelp,
  onNameChange,
  onCountryChange,
  onLanguageChange,
}: Props): ReactElement {
  return (
    <>
      <ScaleTextField
        label={nameLabel}
        helperText={nameHelp}
        styles={compactTextFieldStyles}
        value={name}
        onScaleChange={(event) => onNameChange(String(event.detail.value ?? ''))}
      />
      <ScaleDropdownSelect
        label={countryLabel}
        helperText={countryHelp}
        value={country}
        allowClear
        floatingStrategy="fixed"
        onScaleChange={(event) => onCountryChange(String(event.target.value ?? ''))}
      >
        {countries.map((option) => (
          <ScaleDropdownSelectItem key={option.code} value={option.code}>
            {optionLabel(option)}
          </ScaleDropdownSelectItem>
        ))}
      </ScaleDropdownSelect>
      <ScaleDropdownSelect
        label={languageLabel}
        helperText={languageHelp}
        value={language}
        allowClear
        floatingStrategy="fixed"
        onScaleChange={(event) => onLanguageChange(String(event.target.value ?? ''))}
      >
        {languages.map((option) => (
          <ScaleDropdownSelectItem key={option.code} value={option.code}>
            {optionLabel(option)}
          </ScaleDropdownSelectItem>
        ))}
      </ScaleDropdownSelect>
    </>
  );
}
